import { spUrl, notifyError } from "utils";

import { groupRoles as constants } from "store/constants";
import { actionLoaderFactory } from "store/factories/fetchable";
import { IS_DEV } from "globals/constants";
import { api } from "services";


const factory = actionLoaderFactory(constants, constants.GROUP_ROLES);

export const findGroupRoles = () => {
	return factory.createLoaderAction(
		api.groupRoles.get,
		[
			(response) => {
				factory.setData(response);
			},
			(error, { getState }) => {
				const message = IS_DEV ? error.message : getState().dictionary.common.groupRoles.rolesNotFound;

				notifyError(message, error)
				factory.setError(message);
			},
		],
	);
};
